import type { Plugin } from "vue";

interface OneTrustOptions {
  domainScripts: Record<string, string>;
}

declare global {
  interface Window {
    OptanonWrapper?: () => void;
  }
}

export const oneTrustPlugin: Plugin<OneTrustOptions> = {
  install: (_app, options) => {
    // Only load OneTrust if not in an iframe
    if (window.self !== window.top) {
      return;
    }

    const { domainScripts } = options;
    const hostname = window.location.hostname;

    // Get domain script (use "test" key for test/dev environments)
    const domainScript =
      domainScripts[hostname] || domainScripts["test"] || "019b2383-8472-7f2a-b2f9-4b58aa01c356-test";

    const script = document.createElement("script");
    script.src = "https://cdn.cookielaw.org/scripttemplates/otSDKStub.js";
    script.setAttribute("type", "text/javascript");
    script.setAttribute("charset", "UTF-8");
    script.setAttribute("data-domain-script", domainScript);
    script.async = true;

    const firstChild = document.head.firstChild;
    if (firstChild) {
      document.head.insertBefore(script, firstChild);
    } else {
      document.head.appendChild(script);
    }

    window.OptanonWrapper = () => {};
  },
};
